import { render } from "./ToastWrapper.vue?vue&type=template&id=e6823fbc"
import script from "./ToastWrapper.vue?vue&type=script&lang=js"
export * from "./ToastWrapper.vue?vue&type=script&lang=js"
script.render = render

export default script